import { useMemo } from 'react';

import { AppModel, useApp } from '../../../modules/Apps';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';
import { ReadOnlyFormDrawer } from '../../common/ReadOnlyFormDrawer';
import { ViewErrorState } from '../../common/ViewErrorState';
import { ViewLoadingState } from '../../common/ViewLoadingState';

import { AppModelToFormValues, AppSettingsForm } from './AppSettingsForm';

interface ReadOnlyAppSettingsDrawerProps {
  state: PopoverStateReturn;
  app: AppModel;
}

export function ReadOnlyAppSettingsDrawer({ app, state }: ReadOnlyAppSettingsDrawerProps) {
  const { data, isLoading, isError } = useApp(app?.appId || '');

  const initialValues = useMemo(() => (data ? AppModelToFormValues(data) : undefined), [data]);

  if (isError) {
    return <ViewErrorState />;
  }

    if (isLoading || !initialValues) {
      return <ViewLoadingState />;
    }

  return (
    <ReadOnlyFormDrawer
      initialValues={initialValues}
      title="View App"
      subtitle="App settings"
      state={state}
    >
      {() => <AppSettingsForm readOnly />}
    </ReadOnlyFormDrawer>
  );
}
